import React from "react";
import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import filterChildren from "../../../utils/Children/filterChildren";
import "./Table.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const TableHeader = _ref => {
  let {
    id = "",
    className = "",
    style = {},
    children = [],
    secondaryDataList = []
  } = _ref;
  const tableHeaderClass = cn("align-middle w-full text-text-blue leading-4", className);
  const newChildren = filterChildren(children, {
    secondaryDataList
  });
  const newChildrenWithFunc = React.Children.map(newChildren, (child, index) => /*#__PURE__*/React.cloneElement(child, {
    columnIndex: index
  }));
  return /*#__PURE__*/_jsx("thead", {
    id: id,
    className: tableHeaderClass,
    style: style,
    children: newChildrenWithFunc
  });
};
TableHeader.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /**
   * children props for content inside
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Data (in columns) to hide passed from TableRow component
   * @ignore
   */
  secondaryDataList: PropTypes.array
};
export default TableHeader;
//# sourceMappingURL=TableHeader.js.map